import type { BuildingEntityHandle } from "building-types/entities/buildingEntityHandle";

export interface GeneratedPageViewHandle {
  readonly type: "GENERATED_PAGE_VIEW";
  readonly pageHash: string;
  readonly planSetTemplateConfigId: string | undefined;
}

export enum GeneratedEntityPrefix {
  GeneratedPageView = "generatedPageView",
  BuildingEntity = "buildingEntity",
}

export interface GeneratedEntityHandle {
  readonly type: "GENERATED_ENTITY";
  readonly entity: GeneratedEntitySubHandle | BuildingEntityHandle;
}

export interface GeneratedBuildingEntityHandle {
  readonly type: "GENERATED_ENTITY";
  readonly entity: BuildingEntityHandle;
}

export type GeneratedEntitySubHandle = GeneratedPageViewHandle;
export type GeneratedSubEntityType = GeneratedEntitySubHandle["type"];

export type GeneratedEntityHandleTyped<T extends GeneratedEntitySubHandle | BuildingEntityHandle> =
  GeneratedEntityHandle & {
    readonly entity: T;
  };
